import * as React from 'react';
import styled from 'styled-components';

interface StyledProps {
    height?: number;
}

// WORKAROUND: There is a bug in Highcharts causing charts not properly reflowing inside flex-items. Wrapping the chart inside
// an absolutely positioned container is a workaround and wrapping that container inside relatively positioned container
// retains the intended shape of the container.
const RelativeContainer = styled.div<StyledProps>`
    position: relative;
    height: ${props => (props.height ? props.height + 'px' : '265px')};
`;

const AbsoluteContainer = styled.div`
    position: absolute;
    width: 100%;
`;

interface Props {
    height?: number;
    children: React.ReactNode;
}

export const HighchartsFlexWorkaroundContainer = (props: Props) => {
    return (
        <RelativeContainer height={props.height}>
            <AbsoluteContainer>{props.children}</AbsoluteContainer>
        </RelativeContainer>
    );
};
